import { render, staticRenderFns } from "./PortfolioMasonryWide.vue?vue&type=template&id=242911a9&"
import script from "./PortfolioMasonryWide.vue?vue&type=script&lang=js&"
export * from "./PortfolioMasonryWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports